<template>
  <div>
    <el-dialog
      title="修改文件"
      :visible.sync="show"
      width="800px"
      :before-close="handleClose"
    >
      <MyFileUpload
        :upLoadFileList="fileList"
        @uploadSuccess="handleUploadSuccess"
      />

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// components
import MyFileUpload from "@/components/MyFileUpload/index.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    MyFileUpload
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    //这里存放数据
    return {
      fileList: []
    };
  },
  methods: {
    handleClose() {
      this.$emit("close", false);
    },
    handleUploadSuccess(e) {
      this.$emit("uploadSuccess", e);
    },
    clear() {
      this.fileList = [];
    }
  }
};
</script>

<style scoped lang="less"></style>
